import React from 'react';
import { motion } from 'framer-motion';
export function VideoSection() {
  return;
}